// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import VirtualParticipantLayout from './VirtualParticipantLayout';

export default VirtualParticipantLayout;
